import { Box } from '@mui/material';
import Header from './Components/Header';
import Listt from './Components/Listt';
import './App.css';

function App() {
  return (  
    <Box width='100%'>
      <Header />
      <Listt />
    </Box>
  );
}

export default App;
